import SenderImageViewState from '../../store/schema/SenderImageViewState';
import toggleSenderImage from '../../actions/senderImage/toggleSenderImage';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

const toggleSenderImageMutator = mutator(toggleSenderImage, () => {
    const store = getOptionsStore();
    const viewState = store.activeViewState as SenderImageViewState;

    viewState.isSenderImageEnabled = !viewState.isSenderImageEnabled;
    viewState.isDirty = true;
});

export default toggleSenderImageMutator;
